import { axiosClient } from "../axios";

export function importQuizzes(jsonObject) {
  return axiosClient.post("import/quizzes/json", jsonObject);
}
